import type { Arealplan } from '@origo/arealplan';

export type { Arealplan };

export type SectionFilterValue = 'all' | 'with-sections' | 'without-sections';

export type PlanPublishStatus = 'ikke-påbegynt' | 'utkast' | 'publisert';

export interface PlanFilters {
    statuses: string[];
    types: string[];
    vertikalNivaer: string[];
    dateFrom: Date | null;
    dateTo: Date | null;
    sectionFilter: SectionFilterValue;
    innholdsStatuser: PlanPublishStatus[];
}

export const emptyFilters: PlanFilters = {
    statuses: [],
    types: [],
    vertikalNivaer: [],
    dateFrom: null,
    dateTo: null,
    sectionFilter: 'all',
    innholdsStatuser: [],
};

export interface FilterOption {
    value: string;
    count: number;
}

export type SortField = 'planNavn' | 'planId' | 'planStat' | 'ikraft';
export type SortDirection = 'asc' | 'desc';

export interface SortOption {
    field: SortField;
    direction: SortDirection;
    label: string;
}

export const sortOptions: SortOption[] = [
    { field: 'planNavn', direction: 'asc', label: 'Navn (A–Å)' },
    { field: 'planNavn', direction: 'desc', label: 'Navn (Å–A)' },
    { field: 'planId', direction: 'asc', label: 'Plan-ID (stigende)' },
    { field: 'planId', direction: 'desc', label: 'Plan-ID (synkende)' },
    { field: 'ikraft', direction: 'desc', label: 'Nyeste ikrafttredelse' },
    { field: 'ikraft', direction: 'asc', label: 'Eldste ikrafttredelse' },
];
